import { default as CommonState } from './state'
import mutations from './mutations'
import actions from './actions'
import getters from './getters'

const state = <CommonState>{
  notifications: [],
  errorStatus: false
}

export default {
  state,
  mutations,
  actions,
  getters,
  namespaced: true
}
